module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "flourish",
      "src": "images/flourish.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("February 13, 1866")])])]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('span', {
    staticClass: "s3"
  }, [_vm._v("T")]), _vm._v("he door on the general store slammed open and the stagecoach driver clumped across the board walkway, halting at the edge to bite off a hefty chaw from his newly-purchased tobacco plug. One of the coach horses pricked its ears and whuffed out a steamy cloud of breath as it turned its head toward the voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Danged fool passengers,\" the driver grumbled around the bulge in his cheek. \"Got nothin' better to do than set inside and rest their legs and backsides, while I ride up there in the weather. Then they 'spect me to be their lackey and carry their bags back to the hotel, just 'cause I didn't stop there an' let them out!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I heard that!\" Shanna pushed the door she had caught in mid backswing open further and marched after the driver. \"I'll report your insolence! Don't you think I won't!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The driver rolled his eyes and shook his head before he turned around. \"You an' that boy can carry your own bags. Don't look to me like there's a derned thing wrong with neither one of you.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Realizing her little brother had followed her outside didn't calm Shanna's anger a bit. \"Our passage money entitles us to your assistance in handling our baggage. Every other driver we've had on this trip gave us that courtesy.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yeah, well those other drivers probably didn't have to wait an extra fifteen minutes in the morning for you to primp your face. You put me behind schedule, and now I gotta make up the time.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The driver climbed into his seat as Shanna glared at him indignantly. Fix her face, indeed. All she'd been trying to do was at least get her upper body washed and her dress changed. She darned sure hadn't lingered over that breakfast of half-cooked oatmeal.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You're a disgrace,\" she finally spat at the driver as he reached for the reins. \"I'm going to make that report in writing, not just verbally. I'm also going to tell the company how rude you were to Toby and me at the waystation this morning, and ask them to discipline you.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Won't do you no good,\" the driver said with a sneer. \"Coach lines can't hardly get drivers these days, 'specially ones good with a gun—an' I am. The lines are makin' money 'cause all the train tracks was tore up in the war, an' they ain't about to fire me just 'cause I won't haul your blasted bags to the hotel. Should've brought your fancy-pants maid with you, you wanted someone to wait on you hand and foot!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He spit a glob of tobacco juice over the side of the coach and it spattered on the step to the walkway, just below Shanna's feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna instinctively jumped back, her face contorting with fury. \"You... you barbarian! I hope every one of your darned horses go lame before you get to your next stop, and you have to walk fifty miles!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The driver pursed his lips again, then thought better of it. He released the brake and picked up the whip, cracking it over the team's heads. The coach surged forward amid a jingle of harness and plops of pancake-size hooves, leaving Shanna nothing to yell at but the rear of the departing vehicle.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Still, she swept her skirts up and, avoiding the glob of tobacco spittle, climbed down to the second step. With her fist half raised, it suddenly dawned on her how ridiculous she would look to her five-year-old brother if she shouted the words pushing at her throat. Lord, that would be some example for Toby!")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Instead, she gazed up at the sky while she breathed deeply and tried to smooth the anger from her face before she looked at Toby. A biting wind chilled her cheeks and the bank of purple-black clouds scuttling overhead foretold yet another blizzard on the way, perhaps as bad as the other two storms they had encountered on their journey.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("For just a second, she felt a stab of sympathy for the coach driver, having to fight to keep his schedule in the inclement weather. But she quickly shifted her concern to the horses. That old coot could freeze for all she cared.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Shanna, are you gonna stand there all day?\" Toby asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna gave a start and finally dropped her arm, unclenching her fist and lifting her skirts again. \"I'm coming, Toby,\" she said as she climbed the steps. \"You must be freezing.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yeah,\" Toby admitted. \"And I thought you were freezing there for a minute. You looked like you were gonna run after the stagecoach, then you just stood there like you couldn't move. You sure looked funny.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna made a valiant attempt to overlook Toby's giggle, smoothing at her cloak and searching in her pockets for her gloves. Trying to appear nonchalant as she pulled out her gloves and worked her hands into them, she turned so she could glance up and down the street. Luckily, she only saw vacant hitching rails, even in front of the two saloons on down the street.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She breathed out a sigh of relief. The inhabitants of Liberty, Missouri, appeared to be taking shelter from the approaching storm. She didn't see even one other person on the boardwalks who could have witnessed the spectacle she had made of herself.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Liberty, Missouri. Good grief, she hadn't even known there was a town called Liberty in Missouri until a few weeks ago.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody Garret stepped out of the telegraph office on the opposite side of the street. A satisfied smirk creased his full lips as he stuffed his copies of the telegrams into the pocket of his sheep-skin lined coat.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He'd told Aunt Bessie a search would be useless. No woman of sane mind would travel very far through the war-ravaged South right now—especially for the paltry salary he could offer. Now maybe Bessie would quit being such a pain in the as... neck and hoist her elderly fanny back out to the plantation—and he could get a decent, woman-cooked meal for a change.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The half of cinnamon-laden apple pie and two glasses of milk from the well house for breakfast that morning hadn't really appeased his appetite. But it was better than wrestling that black monstrosity of a wood stove into coughing up an edible meal. Aunt Bessie would definitely not have approved, though.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody's smirk dissolved into a wry grin. Twenty-five years old, a widower with a small child, and a war behind him, and he still cringed at the thought of a censuring look from his elderly aunt.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A flash of sunlight caught the corner of Cody's eye. He briefly glanced at the cloud-laden sky, then realized his mistake. Across the street he noticed what seemed to be the only other two people in town braving the frigid weather.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He didn't recognize either of them and gathered they had arrived on the stage. And he sure as hell would have remembered that woman if he'd seen her before. Or at least that shining, blond hair—the only bright spot of color in the stark, winter day.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She bent down and tucked the little boy's muffler more securely around his neck, and Cody sighed in disappointment when she straightened and pulled the hood of her cloak forward with a graceful movement.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Lucky man, whoever that woman belongs to,")]), _vm._v(" Cody thought to himself as she walked over to the carpetbags sitting outside the store. And most definitely female. His mouth quirked in appreciation of the swaying gait the long, woolen cloak couldn't conceal as she trudged slowly up the walkway.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Probably headed to the hotel,\" Cody murmured. \"Reckon I ought to go over there and offer to help with those bags. The one that little mite beside her's carrying is almost as big as he is.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A gust of icy wind hit Cody as he stepped down into a street still muddy beneath a thin crust forming in the cold air. He glanced overhead as he grabbed his black Stetson and clamped it more firmly over his chestnut hair, then stopped abruptly when he dropped his gaze from the sky and found another sign of life in town.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Three riders—mounted on blooded horses like Cody hadn't seen around town since before the war—rode slowly up the street. Long dusters flapped beside their stirrups and hats pulled down almost to their noses shadowed their faces. A glimpse of movement in the alley beside the bank caught Cody's attention, and he could barely detect the outlines of two more horses, standing just far enough back to be almost invisible from the street.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody's senses sharpened and his eyes narrowed. His skin crawled with the same feeling he'd had the day he avoided a well-concealed ambush on his company during the war, and the hair on the back of his neck actually prickled. It took him only a split-second to measure the distance between the woman and the bank.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Trusting his instincts, Cody leapt back onto the walkway and pushed open the telegraph office door. His voice cut through the quiet office. \"Ed, go out the back way and find the sheriff! Tell him to get over to the bank!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What's going on, Cody?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Whatever it is, I don't like the looks of it. Have Dan bring his rifle and deputies!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ed scrambled from his chair, his face strained with worry. \"Cody, all my money's in that bank.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"So's mine and everyone else's in the county,\" Cody said grimly. \"Move!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ed ran for the back of the office as Cody slammed the door. Despite the biting wind, he unbuttoned his heavy coat and slipped the loop from the handle of his sixgun as he angled across the street. Maybe he was wrong. Hell, he hoped he was wrong, but he'd rather look like a too-cautious fool in front of Dan than a gullible one.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Glancing up the street toward the bank, Cody saw the three horses now riderless and a fourth man he hadn't noticed before sitting in his saddle, holding their reins. The woman and child were approaching the land office, the last building before the alley beside the bank. And the bank was between them and the hotel.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Ma'am!\" Cody called, though he had little hope his voice would carry over the wind. \"Ma'am, wait up a minute!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna stopped and frowned, puzzled at the slight sound that had broken into her concentration. Peering over her shoulder, she saw a tall, broad-shouldered man hurrying up the street in her direction. He wore what she had come to think of as working clothes the further south she travelled—a heavy coat, denim jeans and boots. But even at this distance she could tell his denims fit much better than on most of the men she had encountered—or maybe his body was just better proportioned.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He wasn't close enough to make out the features on the face beneath the hat brim, but one thing she could tell. The man's boots were sinking in mud and clumps of other matter left behind by the horses, spattering clods of muck on the denims, which tightly encased his muscular legs. Obviously, she sniffed to herself, they didn't have street cleaners here.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna shrugged and placed a hand on Toby's shoulder to urge him forward again. The man couldn't be calling her—she sure didn't know anyone in this town.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She didn't particularly care about meeting anyone in this town, either, especially if they were anything like that ill-mannered coach driver. It was just another mindless stop on her and Toby's journey, and right now the promise of a soft bed and hot bath at a real hotel urged her onward.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Ma'am!\" came the voice again. \"You there with the child. Wait up!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Shanna, I think that man's talking to us.\" Toby twisted from beneath Shanna's hand and looked out into the street. \"Do you think he's a cowboy?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Hum?\" And a hot, well-prepared meal. She hoped that hotel had a decent cook. She didn't even want to think about what might have been in the half-congealed stew served at the wayside stop last evening.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna halted again and glanced behind her. A tired sigh escaped her lips as she retraced a few steps and reached down to take her little brother's small hand in her own. Wasn't she ever going to get to the hotel?")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Come on, Toby. It's freezing out here and I can't wait to soak in a hot bath.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"But Shanna, it's not Saturday,\" Toby grumbled as he obeyed the tug on his arm and followed his sister.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody glanced at the lone rider holding the horses once more as he climbed the steps to the walkway. The man straightened his slouched shoulders and shifted nervously in his saddle, his head swiveling from Cody back toward the bank window. His hand swept his duster behind him, then rested on his sixgun.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody reached for his own gun, dropping his arm before he could pull it from the holster. Jesus, that woman and child would be caught in a crossfire if shooting started.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Just then, five more riders emerged from the trees a few hundred yards from the edge of town, galloping their horses at breakneck speed toward the bank.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Hell and damnation,\" Cody muttered. \"Hurry up, Dan.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Where the blue blazes "), _c('i', [_vm._v("was")]), _vm._v(" the sheriff? Cody cautiously started after the woman, keeping his eyes on the lone horseman in case he pulled his gun, but realizing there wasn't really a damned thing he could do about it as long as that crazy little fool and her small companion were in the line of fire. Why the hell didn't she realize she was walking straight into danger?")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Typical woman,\" Cody growled under his breath. \"Got her mind too full of feminine poppycock to notice the devil if he swished his tail right in her face!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Stop right there, lady!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna's carpetbag thudded on the walkway and her panic-stricken eyes centered on the black bore of the pistol the man on horseback aimed at her and Toby from across the alley. Frantically she tugged Toby's small body close to her, her terror warring with the need to protect her brother.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"P... put that gun away!\" she demanded. \"What in the world do you think you're doing?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The gunman's eyes flickered and the pistol barrel shifted slightly. \"You!\" he shouted.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The pistol barked and Shanna screamed. Splinters of wood sprayed the arm of her cloak when the bullet buried itself in the wall at her back. Hysterical with fear, Shanna stumbled backward, pushing Toby behind her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Stay still, lady,\" a voice hissed. \"For God's sake, don't try to run. He'll shoot you and the boy both!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The sibilant warning terrified Shanna further, but she bit down on her lower lip, stifling her next scream and clogging the terror in her throat. Behind her, Toby whimpered and Shanna's fingers tightened on his arm until he quieted. Ever so slowly, Shanna swiveled her eyes away from the pistol barrel toward the voice. The mud-spattered figure of the man who had been crossing the street stood a bare yard from her, his hands in the air, a dangerous glint in his eyes and his body tensed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What's going on here?\" someone shouted out in the street.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The man on horseback jerked around in his saddle and the pistol cracked again. The young man running at them clutched his chest and crumbled to the street. His scream of agony was drowned by the rebel yells issuing from the throats of the riders on the five galloping horses, now a scant fifty feet away.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The instant the gunman turned his back, Cody flung himself forward and grabbed the woman and child. Another shot rang out as Cody's shoulder shattered the land office door, his momentum forcing the three of them through the opening. Diving behind the front wall, he carried the other two with him, partially breaking their fall with his own body.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Stay down!\" he ordered. He wrenched his gun from the holster and knocked out a bottom pane of glass. The hammer landed with a dull click when he pulled the trigger and the cylinder jammed tightly when he thumbed the hammer again. He cursed and grabbed the cylinder with his other hand, but it refused to revolve.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A barrage of shots shattered the top window pane. Cody instinctively dropped over the woman and child to shelter them from the falling glass, shoving the useless sixgun back into the holster. The woman grabbed his neck in a stranglehold with one arm, little whimpers of fear puffing her breath against his neck while she tightly clasped the boy in her other arm. He had to get them to a safer place.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What the hell's going on out there, Cody?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody loosened the woman's arm enough to turn his head toward the wizened figure barely poking his head over the wooden counter bisecting the room. \"A gang of men are robbing the bank, Tom!\" he called. \"My gun's jammed! You got a rifle back there?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Hell, yeah. But I'm not going out there. That's the sheriff's job!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody pried the woman's arm free and stiffened his arms to raise his body a few inches. Shaking his shoulders, he flung shards of glass from his coat and gazed down at the frightened faces beneath him. Two identical pairs of terrorized blue eyes met his.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Listen to me now,\" he said grimly. \"When I get up, I want you two to keep low and crawl across the floor. Go through that gate beside the counter and take shelter with Tom. You'll have to be careful of the glass. Do you think you can do that?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The heart-shaped face of the young woman triggered some buried memory in Cody's mind, which he immediately disregarded when she shook her head frantically and rolled away from him, the little boy in her arms.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No!\" she cried. \"We're safer here behind this wall!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody grabbed her chin, turning her face to him. \"Damn it, I don't have time to argue! Those bullets can penetrate this wall. If you don't want to get that boy killed, move your ass!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna gasped in understanding and tore her eyes away from the hypnotic brown gaze, cold now with anger and frustration. She scrambled to her knees, pulling Toby with her. When the man's hands circled her waist, urging her forward, she squeezed Toby's hand and raised up into a crouch, scurrying across the floor. Toby stumbled awkwardly beside her, while the masculine bulk behind her protected them both from more bullets.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("New shots in the street gave the three figures impetus as they scrambled through the wooden gate. Cody administered a final shove to Shanna and Toby and looked across them at Tom.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That rifle. Where is it?\" Cody demanded.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"In the closet.\" Tom swung his head toward a closet door behind him, but made no move to reach for the doorknob.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody shot him a disgusted look and started for the closet. The woman gave a sob beside him and he hesitated when she cried out, \"Toby. Oh, God, Toby, you're hurt!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody looked down to see the young boy cuddled in the woman's lap, her blond head bent over the small palm cradled in her own. Blood poured from around the piece of glass embedded in the boy's hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I fell on the glass, Shanna,\" the little boy whimpered. \"It hurts!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The woman reached for the embedded glass with shaking fingers, then gave a moan of dismay. She pulled her hand back and shook her head.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Please. Get it out, Shanna,\" the boy cried, tears streaming down his face.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody glanced at the closet door, then back at the boy. Outside in the street, men shouted and horses neighed. The rifle he needed to help defend the town was only a couple feet away. But his immediate concern was for the child, only a year or so older than his own daughter.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody jerked a handkerchief from his denim pocket and sat down by the woman. Tenderly he reached for the young boy's hand and held it firmly while he pulled the glass out and threw it aside. He probed the wound further, assuring himself there was no more glass in it, and the boy gave a gasp of pain. But when Cody scanned his face, the boy shot him a gutsy grimace through the tears.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The remaining panes of glass in the land office window rained onto the floor and a bullet thwacked into the wall above them. Damn it to hell! There was a bank robbery going on out there—and they were stealing "), _c('i', [_vm._v("his")]), _vm._v(" money while he knelt here tending this boy!")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody stifled the urge to shake the woman—remind her that she should be the one caring for the boy. Instead, he grabbed her trembling hand and thrust the handkerchief into it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Wrap his hand for now,\" he growled softly. \"I've got to get out there and help Dan.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When Cody started to pull his hand away, he felt the woman's fingers curl around his own.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Be careful. Please,\" she whispered when he glanced up from their clasped fingers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yeah. Yeah, I will,\" he returned gruffly, surprised at how deep the tender concern in those blue eyes touched him. He gently pried her fingers free and took a steadying breath before he crept to the closet door.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Carefully he reached for the doorknob, wrenching his hand back when the wood just above it splintered from yet another stray bullet. After an unconscious glance over his shoulder to make sure no splinters had landed on the woman, Cody groped for the knob again and swung the door open, reaching inside for the rifle propped in a corner. With it in his hands, he retraced his path to the front window.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cautiously Cody raised his head, aware that the noise in the street had now diminished. The band of robbers was near the edge of town, the main body of horses galloping in a bunch while three men strung out behind covered their retreat. Quickly he flung the rifle to his shoulder and snapped off a shot. One of the fleeing bandits twisted in the saddle, but the rider closest to him reached over and pushed the man forward, onto the horse's neck.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody instinctively reached for the lever on the rifle before realizing it wasn't the Spencer repeater he'd left in his saddle scabbard. The last horse entered the trees beyond town and Cody stared down at Tom's single shot rifle. If he hadn't been distracted by the boy's injury, he'd have had time to search for the reloads in the closet. He gave a grimace of disgust and tossed the rifle aside. There wasn't anything left to shoot at now.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He stood and stared out the broken window until the sheriff emerged from behind a horse trough on the other side of the street. A barber's apron covered Dan's chest and white lather obscured half his face. The two deputies stepped out the door in the building behind the sheriff, wisps of smoke curling from their rifle barrels in the frigid air. One of them ran down the walkway toward the sprawled body in the street.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Y'all all right over there, Cody?\" the sheriff called.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yeah, Dan, go ahead and get Doc for that man out in the street.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We been trying to get to him to see how bad he's hurt, but there were too many of them,\" Dan replied. \"They kept us pinned down so we couldn't even get off a good shot at any of them. That poor son of a gun hasn't moved since we first spotted him, though.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Where the hell is everyone? Why didn't they help?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Inside shaking in their boots, I reckon,\" Dan said scornfully. \"Can't say as I blame them, I guess. That bunch meant business!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cody shook his head and turned from the window, striding to the counter to check on the woman and child. He found them huddled together, the woman's head bent protectively over the boy in her arms. For just a second he glared down at the woman, resenting the fact that his need to protect her and the child had interfered with his aiding Dan—perhaps catching the robbers in a crossfire. Almost every penny he had in the world was in that bank, all of it earmarked for the needs of his daughter and aunt.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It wasn't her fault, he reminded himself just as quickly, realizing how absurd it was to blame the frightened figure on the floor. It was those damned cheap bullets—the only kind available after the war—that had jammed his sixgun.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Are they gone, Cody?\" Tom's strident whisper broke into Cody's concentration.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Huh? Oh, yeah. Yeah, they're gone,\" Cody replied with barely a glance at the old man. He laid a gentle hand on the woman's shoulder instead of the tousled curls the hand strained toward. \"It's safe for you to come out now, ma'am,\" he said in a voice softened with consolation in an attempt to ease her abject fright.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna clutched Toby even tighter, still hearing the echoes of shots and men's shouts in her mind. \"No,\" she moaned with a shake of her head. \"They'll kill us. I can't let anything happen to Toby.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Ma'am, please,\" Cody soothed. He gripped her arms and tugged upward, but she resisted the pressure, still shaking her head. \"It's all right now,\" he reassured her again. \"Come on out of there so we can check the boy's hand a little better and make sure you're all right.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Shanna.\" Toby struggled in Shanna's grasp. \"Shanna, you're crushing me.\" He managed to get his uninjured hand free and swatted at Shanna's shoulder. \"Shanna, let go!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Shanna lifted her head a fraction of an inch and stared down into Toby's face. \"Hush, Toby. There's men... and... and guns. They shot at us! I'll take care of you. I promised you I always would.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Ma'am, the men are gone,\" Cody repeated.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Don't you hear him, Shanna?\" Toby insisted. \"He says they're gone. Come on, Shanna. Let go, so I can breathe.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slowly Shanna loosened her hold on Toby and glanced up at the man standing over her. He gave her an encouraging nod and almost at once a good deal of her fear left her as she studied his warm, brown eyes for a brief instant. She allowed Toby to rise to his feet, grabbing his arm in a firm grip when he tried to move away from her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No! You stay right here with me, Toby!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"But Shanna, I wanna go see what happened out in the street. There's probably all kinds of dead bodies out there! If we don't hurry, they'll carry them off before we get to see them!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Good lord,\" Shanna breathed. \"You're not going anywhere, Toby. You mind me and stay here!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"She's right, son,\" Shanna heard the man standing over them say. Keeping a tight hold on Toby's arm, she pulled her legs under her and awkwardly stood up. The man gripped her shoulders to steady her, his touch gentle, yet firm.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Aw, some big sister,\" Toby grumbled under his breath. He scuffed the toe of one boot against the floor as he gazed longingly at the front of the land office. \"I still wanna see.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That's enough, Toby.\" The hands on her shoulders fell away and Shanna glanced behind her at the broad male chest. She had to tilt her head back at an ungainly angle to see the face above the wide shoulders. He stood so close she could smell the open-air scent of his coat, mixed with the masculine after shave, and reassurance flowed from the velvety pools of eyes set in a ruggedly handsome face.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("A woman could rely on a man like this.")]), _vm._v(" The thought sprang unbidden into Shanna's mind as she found it difficult to tear her gaze away. Trust him with her life, as indeed she and Toby had just done. She cleared her throat to force her voice past the last, lingering terror in her chest.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Toby and I owe you our heartfelt thanks,\" she said earnestly, wishing she could somehow think of stronger words to express her gratitude. But she was still struggling against the slowly receding fright and guilt over dragging Toby into the middle of a shootout. At least, that's what she told herself it was when she fought the urge to fling herself into those protective arms once again.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Abruptly, Cody sucked in his breath and stepped back, the memory surfacing again, demanding his acknowledgement this time. My God, how could he have missed it before? Even the clear, Yankee accent led credence to the nagging suspicion trying to claw its way up through the fast crumbling layers of resistance in his mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He quickly jerked his hat down over his eyes, though a corner of his mind told him she couldn't possibly know him. When he tore his eyes away from her puzzled expression, he glanced down at the child by her side. It couldn't possibly be....")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sensing his change of attitude, Shanna gasped and moved protectively between the man and Toby, drawing the walnut-hued inspection back to her own face. Fighting the thought that this man might be more of a threat than the entire gang of bank robbers and confused at the sudden stab of hurt the cold look now on Cody's face sent through her, she drew herself up to her full height and eyed him warily as she tried to edge past him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Excuse us,\" she said in a tight voice when he thrust out an arm to block her path. \"We need to get to the hotel.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p13"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Who the hell are you?\" he growled deep in his throat.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b97ae2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section5.vue
// module id = 72
// module chunks = 0